import { ButtonsGroup, RadioButtonsSkeleton } from 'components/shared/ButtonsGroup/ButtonsGroup';
import { BlockOrientationFormGroup } from 'components/shared/FormGroup';
import { AddonAction } from 'models/AddonAction';
import { FC, useContext } from 'react';

import { AddonMainFormContext } from '../AddonMainForm.context';

interface OwnProps {
  addonAction?: AddonAction;
  onChange: (addonAction: AddonAction) => void;
}

export const AddonActionComponent: FC<OwnProps> = ({ addonAction, onChange }) => {
  const { isLoading, isReadOnly } = useContext(AddonMainFormContext);
  const availableAddonActions: AddonAction[] = ['Increase', 'Decrease'];

  return (
    <BlockOrientationFormGroup inputId="addonAction" label="addon.actionApplied">
      {!isLoading && addonAction !== undefined && (
        <ButtonsGroup
          className="w-100"
          isDisabled={isReadOnly}
          items={availableAddonActions}
          onSelect={newValue => {
            onChange(newValue[0]);
          }}
          selectedItems={addonAction}
          translationPrefix="addon"
          isRadio
        />
      )}
      {isLoading && <RadioButtonsSkeleton items={availableAddonActions} />}
    </BlockOrientationFormGroup>
  );
};
